import Api from './api';

const slug = 'v1/profiles';
export default {
  getVideoProfiles(videoId) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/${videoId}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getAudienceProfile(audienceProfile) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/audience`, audienceProfile)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteAudienceProfile(profile) {
    return new Promise((resolve, reject) => {
      Api.delete(`/${slug}/${profile._id}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
};
